import { enter, enterActive, exit, exitActive } from "../styles/expansionAnimationStyles.scss";

export const transitionStyles: {
    enter: string;
    enterActive: string;
    exit: string;
    exitActive: string;
} = {
    enter,
    enterActive,
    exit,
    exitActive,
};
